import { useQuery } from "@tanstack/react-query";

import { getPracticeManagementSeedingEmissionFactors } from "services";

import { PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_SEEDING_EMISSION_FACTORS } from "consts";

export const usePracticeManagementSeedingEmissionFactors = (version?: string, country: PracticeManagement.CountryCode = "global") =>
  useQuery({
    queryKey: [PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_SEEDING_EMISSION_FACTORS, country, version],
    queryFn: async () => {
      const factors = await getPracticeManagementSeedingEmissionFactors(version, country);
      return factors.map((factor) => ({
        ...factor,
        editingKey: factor.seedingId,
      }));
    },
    staleTime: 1000 * 60 * 60, // 1h
    gcTime: 1000 * 60 * 24,
  });
